import React from 'react';

const WarehouseTerminal = () => {
  return (
    <div className="warehouse-terminal">
      <div className="page-header">
        <h2>Depo Terminali</h2>
        <p>Depo terminal işlemlerini yönetin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default WarehouseTerminal; 